module.exports = __webpack_public_path__ + "static/media/discuss.ab2b85b9.jpeg";